// extracted by mini-css-extract-plugin
export default {"cls1":"GroupCsvUpload-StyledError_cls1__x+LeD","cls2":"GroupCsvUpload-StyledError_cls2__cdkNp GroupCsvUpload-StyledError_cls1__x+LeD"};